import { SetCache } from './usecases/set-cache'

export class SetLocalStorage implements SetCache {
  set(key: string, value: string): void {
    window.localStorage.setItem(key, value)
  }
}
